import { apiWithkey } from "../axios";
import { baseApiURL, cepApi } from "../endpoints";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../utils/setLoadingMessage";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useUserStore from "../../storeModules/useUserStore";
import sleepAwait from "../../utils/sleepAwait";
import findStep from "../../screens/bot/stepModules/findStep";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import sendTag from "../../utils/sendTag";
import {
  normalizeAddressValue,
  sanitizeAddressInput,
  getAddressReviewStep,
} from "../../utils/addressRules";

const fakeLoad = useInitialConfigStore.getState().fakeLoad;

const normalizeApiAddressValue = (value) =>
  value ? normalizeAddressValue(value) : value;

const getCep = async () => {
  setLoadingMessage();

  const { cep } = useUserStore.getState().contrato;
  const url = `${baseApiURL}${cepApi}?cep=${cep}`;
  const storeCepErrorAt = useUserStore.getState().cepErrorAt;

  return apiWithkey
    .get(url)
    .then(async (response) => {
      const address = response.data.data;
      const userCep = useUserStore.getState().contrato.cep;
      const userContratoData = useUserStore.getState().contrato;
      const userBasicData = useUserStore.getState().basic;
      const userLeadData = useUserStore.getState().lead;

      await sleepAwait(fakeLoad);
      removeLoadingMessage();

      if (!address) {
        useBotControlStore.setState({
          currentStep: findStep("cep_nao_encontrado").index,
        });
        return;
      }

      const logradouro = normalizeApiAddressValue(address.logradouro);
      const bairro = normalizeApiAddressValue(address.bairro);
      const cidade = normalizeApiAddressValue(address.cidade);
      // O complemento não tem passo para o usuário corrigir nem é enviado na
      // proposta, então é ajustado às regras aqui mesmo.
      const complemento = address.complemento
        ? sanitizeAddressInput(
            normalizeAddressValue(address.complemento),
            "complemento",
          ).value
        : address.complemento;

      if (address?.cep) {
        useUserStore.setState({
          basic: {
            ...userBasicData,
          },
          lead: {
            ...userLeadData,
          },
          contrato: {
            ...userContratoData,
            bairro,
            cep: address.cep,
            cidade,
            complemento,
            estado: address.estado,
            logradouro,
            numero: address.numero,
          },
        });
      }

      // Falta rua/bairro ou algum campo ficou fora do padrão do banco: o
      // usuário corrige nos passos de endereço.
      if (getAddressReviewStep({ logradouro, bairro, cidade })) {
        useBotControlStore.setState({
          currentStep: findStep("erro_cep").index,
        });

        return;
      }

      useBotControlStore.setState({
        currentStep:
          storeCepErrorAt === "cep-first-input"
            ? findStep("agradecimento_cep").index
            : findStep("revisao_dados_pessoais").index,
      });

      return response;
    })
    .catch(() => {
      useBotControlStore.setState({
        currentStep: findStep("cep_nao_encontrado").index,
      });
      removeLoadingMessage();
    });
};

export { getCep };
